const STRICT_JSON_MARKER = 'Верни строго JSON';
const STRICT_JSON_LINE_RE = /^.*Верни строго JSON.*$/m;

export type EditablePrompt = {
  editable: string;
  lockedSuffix: string;
};

export function splitEditablePrompt(prompt: string): EditablePrompt {
  const match = prompt.match(STRICT_JSON_LINE_RE);
  if (!match || match.index === undefined) {
    return { editable: prompt, lockedSuffix: '' };
  }

  return {
    editable: prompt.slice(0, match.index).trimEnd(),
    lockedSuffix: prompt.slice(match.index).trimStart(),
  };
}

export function composePromptForSave(
  editable: string,
  lockedSuffix: string,
): string {
  const body = editable.trimEnd();
  const suffix = lockedSuffix.trim();
  if (!suffix) return body;
  if (!suffix.includes(STRICT_JSON_MARKER)) return body;
  return body ? `${body}\n${suffix}` : suffix;
}
